/** Shopify CDN: Minification failed

Line 12:2 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 13:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 17:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 22:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:16 Transforming const to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('button-tabs')) {
  class ButtonTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('button'));
      this.listener();
    }

    listener() {
      this.buttons.forEach((element) => {
        element.addEventListener('click', (event) => {

          if (element.classList.contains('button--secondary')) { //set activity to current button
            element.classList.remove('button--secondary');

            const activeImg = element.closest('.shopify-section').querySelector(`[data-tab-block-id="${element.dataset.tabButtonId}"]`);
            activeImg.classList.add('active'); //show active img

            this.buttons.forEach((elementSecond) => { //remove activity from another button
              if (!elementSecond.classList.contains('button--secondary') && elementSecond !== element) {
                elementSecond.classList.add('button--secondary');

                const notActiveImgAlready = elementSecond.closest('.shopify-section').querySelector(`[data-tab-block-id="${elementSecond.dataset.tabButtonId}"]`);

                notActiveImgAlready.classList.remove('active'); //hide active img
              }
            });
          }
        });
      })
    }
  }

  customElements.define('button-tabs', ButtonTab);
}
